(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewHourReport.controller:CrewHourReportCtrl
	 *
	 * @description
	 *
	 */
	angular.module('crewHourReport').controller('CrewHourReportCtrl',
			CrewHourReportCtrl);

	function CrewHourReportCtrl(CommonMasterData, $sce, CommonLogicService, CrewingHelper, EventManagerService, ManageUserServices) {
		var vm = this;
		vm.ctrlName = 'CrewHourReportCtrl';
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : null,
        status : null,
        crewIds : '',
        selectedCrewId : null,
        excludeOtherHubCrew:false,
        employerHubs : null
			},
			masterList : {
				crewTypeList : [],
        statusList:[],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
        crewIdsInvalid : false,
        isCrewIdsLoaded : false,
        employerHubs : []
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
      validateCrewIdsAndSearch(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}

      if (flag === 'crewType') {
        if (typeof(vm.model.searchCriteria.crewType) === 'undefined') {
          vm.model.masterList.isCrewIdsLoaded = false;
        } else {
          loadCrewListByType();
         // vm.model.masterList.isCrewIdsLoaded = true;
        }
      } else if (flag === 'crewId' || flag === 'toDate' || flag === 'fromDate') {
      } else if (flag === 'addId') {
        addCrewIDs();
      } else if (flag !== '') {
        removeCrewIDs(flag);
      }
		};

    function loadCrewListByType(){
      var param={};
      param.crewType = vm.model.searchCriteria.crewType.crewTypeCode;
      param.active = true;
      CommonMasterData.loadCrewList(param,
        function (response) {
    	  vm.model.masterList.isCrewIdsLoaded = true;
          vm.model.masterList.crewList = CrewingHelper.adaptCrewList(response);
          EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.CREW_LIST_UPDATED);
        },
        function () {
          vm.model.masterList.isCrewIdsLoaded = true;
          console.log('Crew list retrieval error');
        }
      );

    }

    function removeCrewIDs(selected) {
      for( var i = 0; i < vm.model.masterList.crewIdList.length; i++){
        if ( vm.model.masterList.crewIdList[i].crewId === selected) {
          vm.model.masterList.crewIdList.splice(i, 1);
          vm.model.searchCriteria.crewIds.splice(i, 1);
        }
      }
    }

    function addCrewIDs() {
      if(!!!vm.model.masterList.crewIdList){
        vm.model.masterList.crewIdList = [];
      }
      var alreadyAvailable = false;
      for( var i = 0; i < vm.model.masterList.crewIdList.length; i++){
        if (vm.model.masterList.crewIdList[i] === vm.model.searchCriteria.selectedCrewId) {
          alreadyAvailable = true;
        }
      }
      if (alreadyAvailable === false) {
        vm.model.masterList.crewIdList.push(vm.model.searchCriteria.selectedCrewId);
      }
      vm.model.searchCriteria.selectedCrewId = null;
    }

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}


    function validateCrewIdsAndSearch(param) {
      param.crewIds = '';
      if (typeof vm.model.masterList.crewIdList != 'undefined') {
        for( var i = 0; i < vm.model.masterList.crewIdList.length; i++){
          if (i === 0) {
            param.crewIds = vm.model.masterList.crewIdList[i].crewId;
          }
          else {
            param.crewIds = param.crewIds + "," + vm.model.masterList.crewIdList[i].crewId;
          }
        }
      }

      CommonMasterData.getCrewTypesForCrewIds(param.crewIds,param.fromDate,param.toDate, function(response) {
          if (param.crewIds === null || param.crewIds === "" || checkCrewValidity(response)){
            vm.model.masterList.crewIdsInvalid = false;
            searchCrewHourReport(param);
          }
        }, function(error) {
          console.log("Error validating crew ids");
        }
      );
    }

		// search Crew Hour Report
		function searchCrewHourReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'crew_hour.rptdesign', getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["crewType"] = param.crewType.crewTypeCode;
      searchParamMap["crewIds"] = param.crewIds;
      searchParamMap["status"] = param.status.value;
      searchParamMap["excludeOtherHubCrew"] = param.excludeOtherHubCrew;
      searchParamMap["employerHubs"] = '';
      if (!!param.employerHubs && !!param.employerHubs.code) {
        searchParamMap["employerHubs"] = param.employerHubs.code;
      }
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				if (!!vm.model.searchCriteria.crewType
						&& !!vm.model.searchCriteria.crewType.crewTypeCode) {
					return true;
				}
				return false;
			}
		}

    function validateCrewIdsAndSearch(param) {
      param.crewIds = '';
      if (typeof vm.model.masterList.crewIdList != 'undefined') {
        for( var i = 0; i < vm.model.masterList.crewIdList.length; i++){
          if (i === 0) {
            param.crewIds = vm.model.masterList.crewIdList[i].crewId;
          }
          else {
            param.crewIds = param.crewIds + "," + vm.model.masterList.crewIdList[i].crewId;
          }
        }
      }

      CommonMasterData.getCrewTypesForCrewIds(param.crewIds,param.fromDate,param.toDate, function(response) {
          if (param.crewIds === null || param.crewIds === "" || checkCrewValidity(response)){
            vm.model.masterList.crewIdsInvalid = false;
            searchCrewHourReport(param);
          }
        }, function(error) {
          console.log("Error validating crew ids");
        }
      );
    }

    function checkCrewValidity(resultList) {
      if (resultList.length === 1) {
        if (typeof vm.model.searchCriteria.crewType === 'undefined') {
          vm.model.searchCriteria.crewType = {};
          return false;
        } else if (resultList[0] === vm.model.searchCriteria.crewType.crewTypeCode){
          vm.model.masterList.crewIdsInvalid = false;
          return true;
        }
        else {
          vm.model.masterList.crewIdsInvalid = true;
          return false;
        }
      } else {
    	  if(resultList.includes(vm.model.searchCriteria.crewType.crewTypeCode)){
    		  vm.model.masterList.crewIdsInvalid = false;
    		  return true;
    	  }else{
    		  vm.model.masterList.crewIdsInvalid = true;
    		  return false;
    	  }
      }
    }

		(function() {
			// crew type codes
			CommonMasterData.getCrewTypeList(function(crewTypeList) {
				vm.model.masterList.crewTypeList = crewTypeList;

			}, function() {
				console.log('Crew Type list retrieval error');
			});

      vm.model.masterList.statusList = ManageUserServices.searchStatusOptions();
      vm.model.searchCriteria.status = vm.model.masterList.statusList[0];

      CommonMasterData.searchCarriers(
        function (response) {
          for(var index in response.hubCodes) {
            vm.model.masterList.employerHubs.push({"code":response.hubCodes[index],"name":response.hubCodes[index]});
          }
          vm.model.defaultCarrier = response.clientCode;
        },
        function (error) {
          MessageService.error(error);
        }
      );

		})();
	}
}());
